import React from "react";
import { isMobile } from 'react-device-detect';
import {useLocaleContext} from "../../../context/LocaleContext";

export default ({active, visible, onClick}) => {
    const {get} = useLocaleContext();
    const className = 'stream-player-controls-liveButton';
    if (!visible) {
        return null;
    }

    let text = get('player.liveButton.' + (isMobile ? 'mobile.' : '') + (active ? 'active' : 'record'));

    return (
        <button onClick={onClick} className={className + (active ? ` active` : '')}>
            {text}
        </button>
    )
}
